import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";
import StoreBadges from "./StoreBadges";

function DownloadCTA() {
  return (
    <section id="cta" className="py-32 px-8 overflow-hidden relative">
      <motion.div
        className="max-w-5xl mx-auto bg-[#1bc9d1] rounded-[3rem] p-12 md:p-24 text-center text-white relative z-10 shadow-2xl"
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
      >
        <AnimatedSection>
          <h2 className="font-headline text-4xl md:text-6xl font-black mb-8 leading-tight">
            Get SOLID. <br />
            Start exchanging today.
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.15}>
          <p className="text-white/80 text-xl max-w-2xl mx-auto mb-12">
            Download the app and join your neighbourhood's pristine exchange. Free to download on iOS and Android.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3}>
          <StoreBadges className="justify-center" />
        </AnimatedSection>

        <AnimatedSection delay={0.45}>
          <p className="mt-8 text-white/60 text-sm">Live in Maastricht.</p>
        </AnimatedSection>
      </motion.div>

      {/* Background accents */}
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-primary-container/20 blur-[120px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary-container/20 blur-[120px] rounded-full"></div>
    </section>
  );
}

export default DownloadCTA;
